import type { CanvasContext } from './canvas';
import type { EngineState } from '../types';
import type { ButtonImages } from './buttons';
import type { ButtonId } from '../types';
import { drawGrid } from './grid';
import { drawConnector, drawLabels, drawPlayhead, drawTargetHead } from './playhead';
import { drawButtons } from './buttons';

export interface RenderInputs {
  getState: () => EngineState;
  getHover: () => ButtonId | null;
  images: ButtonImages;
}

export function startRenderLoop(cc: CanvasContext, inputs: RenderInputs): () => void {
  let stopped = false;

  function frame(): void {
    if (stopped) return;
    const layout = cc.getLayout();
    const state = inputs.getState();
    const ctx = cc.ctx;
    ctx.clearRect(0, 0, layout.cssWidth, layout.cssHeight);
    drawGrid(ctx, layout);
    drawConnector(ctx, layout, state);
    drawTargetHead(ctx, layout, state);
    drawPlayhead(ctx, layout, state);
    drawLabels(ctx, layout, state);
    drawButtons(ctx, layout, state, inputs.images, inputs.getHover());
    requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);
  return () => {
    stopped = true;
  };
}
